import type { ThreeDTocSearchResult } from '@/interfaces/library'
import {
  getHighlightedFields,
  isMappedPartHighlightedField,
  isThreeDSnapshotTocSearchResult
} from '@/helpers/threeDTocSearch'

export function hasMappedPartMatch (result?: ThreeDTocSearchResult | null) {
  return Object.keys(getHighlightedFields(result)).some(isMappedPartHighlightedField)
}

export function getThreeDSnapshotSearchResult (
  results: ThreeDTocSearchResult[],
  snapshotId: number
) {
  return results.find(result =>
    String(result.entityId ?? '') === String(snapshotId) &&
    isThreeDSnapshotTocSearchResult(result)
  ) ?? null
}
